// MF-200 — Single source of truth for shell paddings, container widths,
// header height, and page-title typography. Apply via `LAYOUT.*` rather
// than ad-hoc Tailwind strings inside shells/pages.
//
// Out of scope: collapsing shells into one `<AppShell>` — that's a candidate
// follow-up after this lands.

export const LAYOUT = {
  container: {
    default: 'max-w-5xl',
    narrow: 'max-w-3xl',
    wide: 'max-w-7xl',
  },
  page: {
    paddingX: 'px-4 sm:px-6 lg:px-8',
    paddingY: 'py-6',
  },
  header: {
    height: 'h-14',
    titleSize: 'text-2xl font-semibold tracking-tight',
  },
  section: {
    gap: 'space-y-6',
  },
} as const;
